import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* fetchOrders(action) {
  try {

    const orders = yield call(() => callGetAPI(SERVER_API.GET_ORDERS, action.data));
    yield put({ type: sagaActions.ORDERS_LOAD, data: orders.data });
  } catch (e) {
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchFetchOrdersAsync() {
  yield takeLatest(sagaActions.ORDERS_LOAD_REQUEST, fetchOrders);
}

export default watchFetchOrdersAsync;
